import { concat } from "ramda";
import { rgbToHex } from "shared/helpers/ColorsHelper";

// Redux Prefix
const prefix = concat("ENTITY:");

const SET_ENTITY = prefix("SET_ENTITY");
const SET_ID = prefix("SET_ID");
const SET_NAME = prefix("SET_NAME");
const SET_PRIMARY_COLOR = prefix("SET_PRIMARY_COLOR");
const SET_SECONDARY_COLOR = prefix("SET_SECONDARY_COLOR");
const SET_HIGHLIGHT_COLOR = prefix("SET_HIGHLIGHT_COLOR");
const SET_CURRENCY_CODE = prefix("SET_CURRENCY_CODE");
const SET_LOCALE = prefix("SET_LOCALE");

const INITIAL_STATE = {
  entityId: "",
  entityName: "",
  entityCountry: "",
  givingConfirmationText: "",
  primaryColor: "",
  primaryColorRgb: "",
  secondaryColor: "",
  highlightColor: "",
  currencyCode: "",
  currencySymbol: "",
  selectedLocale: "en",
  selectCategoryCopy: "",
  minimumGivingDayAmount: "",
  defaultGivingDayAmount: "",
  chaiotCid: "",
  ein: "",
  donationPhoneNumberRequired: true,
};

// Actions
export const setLocale = (locale) => ({
  type: SET_LOCALE,
  payload: {
    locale,
  },
});

export const setEntity = (entity) => ({
  type: SET_ENTITY,
  payload: {
    entity,
  },
});

export const setEntityId = (id) => ({
  type: SET_ID,
  payload: {
    id,
  },
});

export const setEntityName = (name) => ({
  type: SET_NAME,
  payload: {
    name,
  },
});

export const setCurrencyCode = (code) => ({
  type: SET_CURRENCY_CODE,
  payload: {
    code,
  },
});

export const setPrimaryColor = (color) => ({
  type: SET_PRIMARY_COLOR,
  payload: {
    color,
  },
});

export const setSecondaryColor = (color) => ({
  type: SET_SECONDARY_COLOR,
  payload: {
    color,
  },
});

export const setHighlightColor = (color) => ({
  type: SET_HIGHLIGHT_COLOR,
  payload: {
    color,
  },
});

// Reducer
export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ID:
      return {
        ...state,
        entityId: action.payload.id,
      };
    case SET_LOCALE:
      return {
        ...state,
        selectedLocale: action.payload.locale,
      };
    case SET_ENTITY:
      return {
        ...state,
        availableLocales: action.payload.entity.language,
        chariotCid: action.payload.entity.chariot_cid,
        currencyCode: action.payload.entity.currency_code,
        currencySymbol: action.payload.entity.currency_symbol,
        defaultGivingDayAmount: action.payload.entity.default_giving_day_amount,
        ein: action.payload.entity.ein,
        entityCountry: action.payload.entity.country,
        entityId: action.payload.entity.id,
        entityName: action.payload.entity.name,
        featuresEnabled: action.payload.entity.features_enabled,
        givingConfirmationText: action.payload.entity.gift_confirmation_text,
        highlightColor: action.payload.entity.highlight_color,
        language: action.payload.entity.language,
        minimumGivingDayAmount: action.payload.entity.minimum_giving_day_amount,
        paypalMerchantId: action.payload.entity.paypal_merchant_id,
        primaryColor: rgbToHex(action.payload.entity.primarycolor),
        primaryColorRgb: action.payload.entity.primarycolor,
        processingFee: action.payload.entity.processing_flat_fee,
        processingPercent: action.payload.entity.processing_percent,
        secondaryColor: rgbToHex(action.payload.entity.secondarycolor),
        selectCategoryCopy: action.payload.entity.select_category_copy,
        stripePublishableKey: action.payload.entity.stripe_publishable_key,
        paypalVerified: action.payload.entity.paypal_verified,
        quickGiveEnabled: action.payload.entity.quick_give_enabled,
        gravytyPayAccountId: action.payload.entity.gravyty_pay_account_id,
        donationPhoneNumberRequired: action.payload.entity.donation_phone_number_required,
      };
    case SET_NAME:
      return {
        ...state,
        entityName: action.payload.name,
      };
    case SET_PRIMARY_COLOR:
      return {
        ...state,
        primaryColor: action.payload.color,
      };
    case SET_SECONDARY_COLOR:
      return {
        ...state,
        secondaryColor: action.payload.color,
      };
    case SET_HIGHLIGHT_COLOR:
      return {
        ...state,
        highlightColor: action.payload.color,
      };
    case SET_CURRENCY_CODE:
      return {
        ...state,
        currencyCode: action.payload.code,
      };
    default:
      return state;
  }
}
